import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import TrackVisualizer from '@/TrackVisualizer.vue';
  import formatTime from '../utils/formatTime';
  import { vibrate } from '../utils/vibrate';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MusicPlayer',
  setup(__props, { expose }) {
  expose();

  const store = useStore();

  const getTrack = (index: number): File => {
    return store.getters.track(index);
  };

  const getTrackListLength = (): number => {
    return store.getters.trackListLength;
  };

  const getCurrTrack = (): number => {
    return store.getters.currentTrack;
  };

  const updateCurrTrack = (newCurrTrack: number): void => {
    store.commit('refreshCurrentTrack', newCurrTrack);
  }

  const player = new Audio();
  store.commit('refreshPlayer', player);

  const currTime = ref(0);
  const duration = ref(0);
  const currTrack = ref(0);
  const isPlaying = ref(false);
  const trackName = ref('');

  player.addEventListener('timeupdate', () => {
    currTime.value = Math.round(player.currentTime);
    if (player.currentTime === player.duration) {
      const track = getTrack(currTrack.value + 1);
      updateCurrTrack(!!track ?
        currTrack.value + 1 :
        0);
    }
  });

  const pause = () => !!player.src && (isPlaying.value = !isPlaying.value, vibrate(), player.pause());
  const play = () => !!player.src && (isPlaying.value = !isPlaying.value, vibrate(), player.play());

  const playNewTrack = async (index: number) => {
    vibrate();
    
    const track = getTrack(index);
    if (!!!track) return;
    
    trackName.value = track.name;

    if (!!player.src) {
      player.pause();
      player.src = '';
      isPlaying.value = false;
    }

    player.src = URL.createObjectURL(track);
    try {
      await player.play();
      
      isPlaying.value = true;
      duration.value = Math.round(player.duration) || 0;
    } catch (error) {
      console.log('Failed to play, error: ' + error);
    }

    URL.revokeObjectURL(player.src);
  };

  const changeTrack = (direction: number): void => {
    
    const trackListLength = getTrackListLength();
    if (trackListLength === 0) return;
    let nextTrack = currTrack.value + direction;
    nextTrack = nextTrack > trackListLength ?
      0 :
      nextTrack < 0 ?
      trackListLength - 1 :
      nextTrack;
    vibrate();
    updateCurrTrack(nextTrack);
  };

  store.subscribe((mutation, state) => {
    if (mutation.type === 'refreshTrackList') {
      updateCurrTrack(0);
    }

    if (mutation.type === 'refreshCurrentTrack') {
      currTrack.value = getCurrTrack();
      playNewTrack(currTrack.value);
    }
  });

const __returned__ = { store, getTrack, getTrackListLength, getCurrTrack, updateCurrTrack, player, currTime, duration, currTrack, isPlaying, trackName, pause, play, playNewTrack, changeTrack, TrackVisualizer, get formatTime() { return formatTime } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})